import { CanMatchFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { IsLoggedInUseCase } from "@app/core/shared/domain/is-logged-in.use-case";

export const loggedOutUserGuard: CanMatchFn = () => {
  const isLoggedOut = !inject(IsLoggedInUseCase).execute();
  // If the user is logged out, then allow the route to match.
  // Otherwise, redirect to the home page.
  if (!isLoggedOut) {
    inject(Router).navigate(["/"], { replaceUrl: true });
  }
  return true;
};
